export const GROUPS_API_URL = {
  ALL: "/api/users/v1/groups/",
  STORAGE_GROUP: "/api/storage_group/v1/",
  SERVERS: "/api/acl/v1/tree/",
  RULES: "/api/acl/v1/rules/",
  COPY: "/from", // append to RULES
  MANAGES: "/api/users/v1/group/roles",
  CHANGES: "/api/acl/v1/tree/changes/",
  LDAP_GROUP: "/api/users/v1/ldap_groups",
} as const
